<template>
    <div>
        <a-modal :title="modalState.title" :visible="modalState.isShow" :confirm-loading="confirmLoading" width="750px"
            @cancel="handleCancel">
            <a-form-model :model="searchP" layout="inline" ref="searchform" :form="form" style="margin-bottom:20px;">
                <!-- <a-form-model-item label="所属领域" ref="domain" prop="domain">
                    <a-select  v-model="searchP.domain" style="width:100px" placeholder="请选择服务所属领域" >
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="001">前台</a-select-option>
                        <a-select-option key="002">中台</a-select-option>
                        <a-select-option key="003">开放</a-select-option>
                        <a-select-option key="004">基础</a-select-option>
                    </a-select>
                </a-form-model-item> -->

                <a-form-model-item ref="appcode" label="应用编码">
                    <AppAutoComplete ref="appcodeAss" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-model-item>
                <a-form-model-item ref="keyword" prop="keyword" label="关键字">
                    <a-input  v-model="searchP.keyword" placeholder="服务KEY或服务配置或描述"></a-input>
                </a-form-model-item>

                <a-form-model-item>
                    <a-button type="primary" @click="handleSubmit">筛选</a-button>
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="default" @click="handleSearchReset">重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>

            <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:modalState.rowsType,getCheckboxProps:getCheckboxProps}"
                :columns="columns" :data-source="list" rowKey="servicekey" :pagination="false" />

            <br />

            <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange"
                style="float:right;" show-less-items />
            <br />

            <template slot="footer">
                <div style="float:left;font-weight:bolder;color:green;">已选：{{selectedRowKeys.length}}</div>

                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>
import AppAutoComplete from '@/components/AppAutoComplete'
const columns = [
    {
        title: '所属领域',
        dataIndex: 'domaindesc',
        align: 'center',
        width:80,
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        width:80,
    },
    {
        title: '服务KEY',
        dataIndex: 'servicekey',
        align: 'center',
        width:300,
        ellipsis: true
    },
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            selectedRowKeys: [],
            list:[],
            searchVal:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            searchP:{
                domain:this.modalState.domain,
                keyword:'',
                appcode:''
            },
            form: this.$form.createForm(this),
            originData:[],
            savedPages:[],
            getCheckboxProps: record => ({
                props: {
                    disabled: record.disabled, // Column configuration not to be checked
                }
            }),
            currentAppSelectSearchInput:'currentAppSelectSearchInput'
        }
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props:{
        modalState:{
            isShow:false,
            rowsType:'checkbox',
            selectkeys:[],
            domain:'',
        }
    },
    methods: {
        handlePageChange(params_page){
            this.onModalInit(params_page)
        },
        handleSubmit() {
            this.onModalInit(1)
        },
        handleSearchReset(){
            this.$refs.appcodeAss.value = ''
            this.searchP = {
                keyword:'',
                appcode:''
            }
            this.onModalInit(1)
        },
        handleSearchAppcodeChange(value){
            this.searchP.appcode = value;
        },
        onModalInit(pageNum){
            let that = this;
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:pageNum ? pageNum : 1,
                urlparams:false,
            }
            c_params.appcode = that.searchP.appcode;
            c_params.domain = that.searchP.domain;
            c_params.keyword = that.searchP.keyword;

            that.$store.dispatch({
                type: "servicekey/select",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    let result = res.data.data;
                    result.list.forEach(element => {
                        element.disabled = (this.modalState.selectkeys.indexOf(element.servicekey) != -1);
                    });
                    if(that.modalState.selectkeys.length > 0){
                        that.selectedRowKeys = that.modalState.selectkeys;
                    }
                    that.originData = that.originData.concat(result.list)
                    that.list = result.list;
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.current = result.page;
                }
                else{
                    that.message.error('获取service列表失败')
                }
            })
        },


        onSearchChange(value){
            this.domain = value;
        },
        onSearch(value){
            this.searchVal = value;
            this.onModalInit();
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){

            let current_keys = this.selectedRowKeys;
            let result = [];
            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index];
                let c_item = this.originData.filter(function(n){
                    return element == n.servicekey
                });
                if(c_item.length == 0){
                    result = undefined
                    console.log("未找到对应数据")
                    break;
                }
                result.push(c_item[0])
            }

            this.$emit('onModalHide',result);
            this.selectedRowKeys = [];
        },
        handleCancel(e) {
            e.preventDefault()
            this.selectedRowKeys = [];
            this.modalState.isShow = false;
            this.$emit('onModalHide',undefined);
        }
    },
    mounted() {
    },
    components:{
        AppAutoComplete
    },
    watch:{
        'modalState.isShow'(newVal){
            if(newVal){
                let oringin_data = [];
                this.modalState.selectkeys.forEach(element => {
                    oringin_data.push({
                        servicekey:element
                    });
                });
                this.originData = oringin_data;

                this.onModalInit(1);
            }
        }
    }
};
</script>

<style scoped>

</style>
